module.exports = __webpack_public_path__ + "static/media/cards.d823367f.jpg";